import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  item: any;
}
